/**
 * Deploy-time frontend config.
 *
 * The frontend container writes these PUBLIC values into /config.js at start
 * (per host, from its .env), so one image serves every stage. That script sets
 * window.__PVC_CONFIG__ before the bundle runs. It is absent in local dev, so
 * every field is optional and callers fall back to the build-time
 * import.meta.env.REACT_APP_* values.
 */
export type PvcRuntimeConfig = {
  apiUrl?: string;
  gcpKey?: string;
  mapId?: string;
};

declare global {
  interface Window {
    __PVC_CONFIG__?: PvcRuntimeConfig;
  }
}

export const runtimeConfig = (): PvcRuntimeConfig =>
  (typeof window !== 'undefined' && window.__PVC_CONFIG__) || {};
